




























































































































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class FlightOrderChangeModal extends Vue {
  dialog: boolean = true;
  startDate: Date = null;
  headersFlightSearch: any[] = [];
  mockDataFlightSearch: any[] = [];
  radio: boolean = true;

  created() {
    (this.headersFlightSearch = [
      { text: "", value: "" },
      { text: "Havayolu Adı", value: "company" },
      { text: "Başlangıç-Varış", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNumber" },
      { text: "Kalkış Tarihi", value: "departureDate" },
      { text: "Varış Tarihi", value: "arrivalDate" },
    ]),
      (this.mockDataFlightSearch = [
        {
          company: "URAL AIRLINES ",
          destination: "AER - DME",
          flightNumber: "U6 1518  ",
          departureDate: "15/05/2021 17:10",
          arrivalDate: "15/05/2021 19:30 ",
        },
      ]);
  }

  data() {
    return {
      fromAirportsItems: ["Anapa,Rusya / AAQ", "Abakan,Rusya / ABA"],
      fromAirports: [],

      toAirportsItems: [
        "Antalya,Turkey (AYT-Antalya Int) / AYT",
        "Akabe,Urdun / AQJ",
      ],
      toAirports: [],
    };
  }

  closeDialog() {
    this.$emit("closed");
  }
}
